<template>
  <div class="grade-rank">
    <el-table v-if="gradeRankVal != ''" :data="gradeRankStudentList" border style="width: 100%" height="calc(100vh - 310px)">
      <el-table-column prop="className" label="班级" width="100"></el-table-column>
      <el-table-column prop="studentName" label="姓名" width="150"></el-table-column>
      <el-table-column v-for="(item, index) in gradeRankCourseList" :key="index" :label="item">
        <template slot-scope="{ row }">
          <!-- <span> {{ item.descRate || '无' }}</span> -->
          <span v-if="row.courseInfoList.find((courseItem) => courseItem.courseName === item)">
            {{
              row.courseInfoList &&
              row.courseInfoList.find((courseItem) => courseItem.courseName === item)
                ?.score
            }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalScore" label="总分"></el-table-column>
      <el-table-column prop="avgScore" label="平均分"></el-table-column>
      <el-table-column prop="classRank" label="班级排名"></el-table-column>
      <el-table-column prop="gradeRank" label="年级排名"></el-table-column>
    </el-table>
    <div class="rank-text" v-else>请输入名次查询</div>
  </div>
</template>

<script>
export default {
  props: ['gradeRankVal', 'gradeRankStudentList', 'gradeRankCourseList'],
  data() {
    return {
      tableData: [
        { name: '小白', course1: 0, course2: 0, course3: 0, course4: 0, total: 0, average: 0, classRank: 1, rank: 1, },
        { name: '小红', course1: 0, course2: 0, course3: 0, course4: 0, total: 0, average: 0, classRank: 2, rank: 2, },
        { name: '小明', course1: 0, course2: 0, course3: 0, course4: 0, total: 0, average: 0, classRank: 3, rank: 3, },
      ]
    }
  },

};
</script>

<style lang="scss" scoped>
@import "./gradeRank.scss";
</style>